import { oc } from "@orpc/contract";
import { openapi } from "@orpc/openapi";
import { z } from "zod";
import { type ContractService, errors, paxRoute, sessionRequired } from "../../common";
import { TranscribeBody, Transcription, transcriptionRefusals } from "./schemas";

export const service = {
  group: "speech",
  version: "v1alpha1",
  stage: "alpha",
  title: "Pax Speech API",
  description: "Speech recognition, charged to the signed-in user.",
} as const satisfies ContractService;

export const transcribe = oc
  .meta(
    paxRoute({ auth: { kind: "session" }, minimumTier: "normal", cost: "ai" }),
    openapi({
      method: "POST",
      path: "/api/speech/v1alpha1/transcriptions",
      operationId: "speech.transcriptions.create",
      summary: "Transcribe audio.",
      description:
        "Turns up to 10 MB of audio into text, charged to the signed-in user by the second of audio.",
      inputStructure: "detailed",
      successDescription: "What the audio said.",
    }),
  )
  .errors({ ...sessionRequired, ...errors.badRequest, ...transcriptionRefusals })
  .input(z.object({ body: TranscribeBody }))
  .output(Transcription);
